<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Headline from '@/components/headline.vue';
import PoolTypes from '@/components/pools/pool-types.vue';
import Pools from '@/components/pools/pools.vue';
import Pool from '@/components/pools/pool.vue';
import PoolBets from '@/components/pools/pool-bets.vue';
import Tabs from '@/components/tabs.vue';
import { mapState, mapWritableState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';

export default defineComponent({
  name: 'pools',
  components: { Headline, Tabs },
  computed: {
    ...mapState(usePoolsStore, ['pools']),
    ...mapWritableState(usePoolsStore, ['currentPoolId', 'tab']),
    loading() {
      return false;
    },
    tabs() {
      const pool =
        this.currentPoolId && this.pools
          ? this.pools.find((p) => p.id === this.currentPoolId)
          : null;

      const poolParams = pool ? [pool.name] : [];

      return [
        { id: 'types', name: 'Типы пулов', component: markRaw(PoolTypes), params: [] },
        { id: 'pools', name: 'Пулы', component: markRaw(Pools), params: [] },
        { id: 'pool', name: 'Матчи', component: markRaw(Pool), params: poolParams },
        { id: 'poolBets', name: 'Ставки', component: markRaw(PoolBets), params: poolParams },
      ];
    },
  },
  mounted() {
    this.$router.isReady().then(() => {
      if (+this.$route.params.id) {
        this.currentPoolId = +this.$route.params.id;
      }
      if (this.currentPoolId) {
        this.tab = 1;
      }
    });
  },
});
</script>

<template>
  <template v-if="loading">
    <div class="relative z-10">
      <div
        style="height: 100vh; position: absolute; left: 0; right: 0"
        class="place-content-center text-center w-full bg-opacity-20 bg-black"
      >
        <i class="pi pi-spinner animate-spin text-gray-200" style="font-size: 5em" />
      </div>
    </div>
  </template>
  <teleport to="#title">
    <headline class="mx-4 my-2"> Тотализаторы</headline>
  </teleport>
  <tabs :tabs="tabs" v-model="tab">
    <template v-for="one in tabs" :key="one.id" v-slot:[one.id]>
      <component :is="one.component" />
    </template>
  </tabs>
</template>

<style scoped lang="scss"></style>
